/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

var _mj_prg_dly_els = null;
var _mj_prg_dly_iv = null;

function _mj_prg_dly_elems() {
	if( _mj_prg_dly_els===null ) {
		_mj_prg_dly_els = [];
		let tmp;
		if( (tmp=document.getElementById('page-dim-overlay'))!=null ) _mj_prg_dly_els.push(tmp);
		if( (tmp=document.getElementById('progress'))!=null ) _mj_prg_dly_els.push(tmp);
	}
	return _mj_prg_dly_els;
}

function _mj_prg_dly_reset() {
	if( _mj_prg_dly_iv!==null ) {
		clearInterval(_mj_prg_dly_iv);
		_mj_prg_dly_iv = null;
	}
}

function _mj_prg_dly() {
	for( const el of _mj_prg_dly_elems() ) el.style.display = 'block';
	_mj_prg_dly_reset();
}

export function startProgress( imm, iv ) {
	if( _mj_prg_dly_iv!==null ) return;
	if( imm ) _mj_prg_dly();
	else _mj_prg_dly_iv = setInterval(_mj_prg_dly,iv||350);
}

export function stopProgress() {
	_mj_prg_dly_reset();
	for( const el of _mj_prg_dly_elems() ) el.style.display = 'none';
}


// compat ..
window.startProgress = startProgress;
window.stopProgress = stopProgress;
